/** Matches profile menu: subscribed township + Admin or Finance Manager permit role. */
export const canAccessTownshipConfiguration = (
  userDetails: Record<string, unknown> | null | undefined
): boolean => {
  if (!userDetails) {
    return false;
  }

  const townshipPermits = userDetails.TownshipPermits as unknown[] | undefined;
  const isSubscribed = Array.isArray(townshipPermits) && townshipPermits.length > 0;
  const isAdmin = userDetails.UserRole === 'Admin';
  const isFinanceManager = Boolean(userDetails.isFinanceManager);

  return isSubscribed && (isAdmin || isFinanceManager);
};

export const isTownshipConfigurationTownshipAllowed = (
  userDetails: Record<string, unknown> | null | undefined,
  townshipIdParam: string | undefined
): boolean => {
  if (!userDetails || townshipIdParam == null || townshipIdParam === '') {
    return false;
  }

  if (userDetails.UserRole === 'Super Admin') {
    return true;
  }

  return Number(userDetails.TownshipID) === Number(townshipIdParam);
};

export const getTownshipConfigurationDeniedRedirect = (
  userDetails: Record<string, unknown> | null | undefined
): string => {
  const townshipId = userDetails?.TownshipID;
  if (townshipId != null && townshipId !== '') {
    return `/dashboard/${townshipId}`;
  }
  return '/';
};
